import * as d3 from 'd3';

/* eslint-disable */

export const handleGraphDataRange = (graphData, yearSpan) => {
	const dataArray = JSON.parse(JSON.stringify(graphData));

	let temporaryDataArray = [];
	dataArray.map(({ values, key }) => {
		let valuesArray = [];
		// @ts-ignore
		for (let i = 0; i < values.length; i++) {
			// @ts-ignore
			if (values[i].x >= yearSpan[0] && values[i].x <= yearSpan[1]) {
				valuesArray = [...valuesArray, values[i]];
			}
		}
		temporaryDataArray = [
			...temporaryDataArray,
			{ values: valuesArray, key },
		];
	});

	return temporaryDataArray;
};

export const handleCumulativeGraph = (data) => {
	const dataArray = JSON.parse(JSON.stringify(data));

	const cumulativeDataArray = [];

	for (let i = 0; i < dataArray.length; i++) {
		const values = dataArray[i].values;
		const newValueArray = [];

		for (let pair = 0; pair < values.length; pair++) {
			if (pair > 0) {
				values[pair].y = values[pair].y + values[pair - 1].y;
			}
			newValueArray[pair] = {
				x: values[pair].x,
				y: values[pair].y,
				f: values[pair].f,
			};
		}
		cumulativeDataArray.push({
			values: newValueArray,
			key: dataArray[i].key,
		});
	}

	return cumulativeDataArray;
};

export const handleGraphDataSmoothing = (data, smoothing = 3, freq) => {
	const result = [];
	const dataArray = JSON.parse(JSON.stringify(data));

	for (let i = 0; i < dataArray.length; i++) {
		const values = dataArray[i].values;
		const newValueArray = [];
		for (let pair = 0; pair < values.length; pair++) {
			if (typeof values[pair].f !== 'undefined' && freq == 'abs') {
				delete values[pair].y;
				values[pair].y = values[pair].f;
				delete values[pair].f;
			} else if (
				typeof values[pair].f !== 'undefined' &&
				freq === 'rel'
			) {
				delete values[pair].f;
			}

			const slice = values.slice(
				Math.max(0, pair - smoothing),
				pair + smoothing,
			);
			let avg = 2 * values[pair].y;
			for (let j = 0; j < slice.length; j++) {
				avg += slice[j].y;
			}
			avg = avg / (slice.length + 2);
			newValueArray[pair] = { x: values[pair].x, y: avg };
		}
		result.push({ values: newValueArray, key: dataArray[i].key });
	}

	return result;
};

export function display(graph, isFilterContainerHidden, colors) {
	let w = isFilterContainerHidden ? 1200 : 1200;
	let h = 560;

	let keyc = true,
		keys = true,
		keyt = true,
		keyr = true,
		keyx = true,
		keyd = true,
		keyl = true,
		keym = true,
		keyh = true,
		key1 = true,
		key2 = true,
		key3 = true,
		key0 = true;

	let focus_node = null,
		highlight_node = null;

	const text_center = false;
	const outline = false;

	const nodeSizes = graph.nodes.map((element) => {
		return element.size;
	});

	const linkValues = graph.links.map((element) => {
		return element.value;
	});

	const maxnode = d3.max(nodeSizes);
	const minnode = d3.min(nodeSizes);
	const maxlink = d3.max(linkValues);
	const minlink = d3.min(linkValues);

	const color = d3.scale.ordinal().range(colors);

	const fontsize = d3.scale.linear().domain([minnode, maxnode]).range([1, 2]);

	const linkval = d3.scale.linear().domain([minlink, maxlink]).range([2, 4]);

	const highlight_color = 'darkgrey';
	const highlight_trans = 0.1;

	const size = d3.scale.pow().exponent(1).domain([1, 100]).range([8, 24]);

	const force = d3.layout.force().linkDistance(150).charge(-300).size([w, h]);

	const defaultNodeColor = '#ccc';
	const defaultLinkColor = '#888';
	const nominal_base_node_size = 8;
	const nominal_text_size = 10;
	const max_text_size = 24;
	const nominal_stroke = 1.5;
	const max_stroke = 4.5;
	const max_base_node_size = 36;
	const min_zoom = 0.1;
	const max_zoom = 10;
	const svg = d3.select('div.force').append('svg');
	const zoom = d3.behavior.zoom().scaleExtent([min_zoom, max_zoom]);

	const link_opacity = 0.1;
	const link_opacity_highlight = 0.8;
	const marker_opacity = 0.6;
	const circle_opacity = 1;
	const circle_opacity_highlight = 0.7;
	const g = svg.append('g');
	svg.style('cursor', 'move');

	const linkedByIndex = {};
	graph.links.forEach(function (d) {
		linkedByIndex[d.source + ',' + d.target] = true;
	});

	function isConnected(a, b) {
		return (
			linkedByIndex[a.index + ',' + b.index] ||
			linkedByIndex[b.index + ',' + a.index] ||
			a.index == b.index
		);
	}

	function hasConnections(a) {
		for (const property in linkedByIndex) {
			const s = property.split(',');
			if ((s[0] == a.index || s[1] == a.index) && linkedByIndex[property])
				return true;
		}
		return false;
	}

	force.nodes(graph.nodes).links(graph.links).start();

	// append marker midway on edge

	svg.append('svg:defs')
		.selectAll('marker')
		.data(['middle']) // Different link/path types can be defined here
		.enter()
		.append('svg:marker') // This section adds in the arrows
		.attr('id', 'arrow')
		.attr('viewBox', '0 0 10 10')
		.attr('refX', 12)
		.attr('refY', 3)
		.attr('markerWidth', 20)
		.attr('markerHeight', 8)
		.attr('orient', 'auto')
		.attr('opacity', marker_opacity)
		.append('svg:path')
		.attr('d', 'M0,0L0,6L9,3 z')
		.style('fill', 'darkslategrey');

	const link = g
		.selectAll('.link')
		.data(graph.links)
		.enter()
		.append('path')
		.attr('marker-end', 'url(#arrow)')
		.attr('class', 'link')
		.style('fill', 'none')
		.style('opacity', link_opacity)
		.style('stroke-width', function (d) {
			return linkval(d.value);
		})
		.style('stroke', function (d) {
			if (isNumber(d.size) && d.size >= 0) return color(d.size);
			return defaultLinkColor;
		});

	const node = g
		.selectAll('.node')
		.data(graph.nodes)
		.enter()
		.append('g')
		.attr('class', 'node')

		.call(force.drag);

	node.on('dblclick.zoom', function (d) {
		d3.event.stopPropagation();
		const dcx = w / 2 - d.x * zoom.scale();
		const dcy = h / 2 - d.y * zoom.scale();
		zoom.translate([dcx, dcy]);
		g.attr(
			'transform',
			'translate(' + dcx + ',' + dcy + ')scale(' + zoom.scale() + ')',
		);
	});

	let tocolor = 'fill';
	let towhite = 'stroke';
	if (outline) {
		tocolor = 'stroke';
		towhite = 'fill';
	}

	const circle = node
		.append('path')
		.attr(
			'd',
			d3.svg
				.symbol()
				.size(function (d) {
					return (
						Math.PI *
						Math.pow(size(d.size) || nominal_base_node_size, 2)
					);
				})
				.type(function (d) {
					return d.type;
				}),
		)
		.style(tocolor, function (d) {
			if (isNumber(d.size) && d.size >= 0) return color(d.size);
			return defaultNodeColor;
		})

		.style('stroke-width', nominal_stroke)
		.style('opacity', circle_opacity)
		.style(towhite, 'white');

	const text = g
		.selectAll('.text')
		.data(graph.nodes)
		.enter()
		.append('text')
		.attr('dy', '.35em')
		.style('font-size', function (d) {
			return fontsize(d.size) + 'em';
		});

	if (text_center)
		text.text(function (d) {
			return d.name;
		}).style('text-anchor', 'middle');
	else
		text.attr('dx', function (d) {
			return size(d.size) || nominal_base_node_size;
		}).text(function (d) {
			return '\u2002' + d.name;
		});

	node.on('mouseover', function (d) {
		d3.event.stopPropagation();
		set_highlight(d);
		focus_node = d;
		set_focus(d);
		if (highlight_node === null) set_highlight(d);
	}).on('mouseout', function (d) {
		exit_highlight();
		if (focus_node !== null) {
			focus_node = null;
			if (highlight_trans < 1) {
				circle.style('opacity', 0.5);
				text.style('opacity', 1);
				link.style('opacity', 0.8);
			}
		}
		if (highlight_node === null) exit_highlight();
	});

	function exit_highlight() {
		highlight_node = null;
		if (focus_node === null) {
			svg.style('cursor', 'move');
			if (highlight_color != 'white') {
				circle.style(towhite, 'white');
				circle.style('opacity', circle_opacity);
				text.style('font-weight', 'normal');
				link.style('stroke', function (o) {
					return isNumber(o.score) && o.score >= 0
						? color(o.score)
						: defaultLinkColor;
				});
				link.style('opacity', link_opacity);
			}
		}
	}

	function set_focus(d) {
		if (highlight_trans < 1) {
			circle.style('opacity', function (o) {
				return isConnected(d, o)
					? circle_opacity_highlight
					: highlight_trans;
			});

			text.style('opacity', function (o) {
				return isConnected(d, o) ? 1 : highlight_trans;
			});

			link.style('opacity', function (o) {
				return o.source.index == d.index || o.target.index == d.index
					? link_opacity_highlight
					: highlight_trans;
			});
		}
	}

	function set_highlight(d) {
		svg.style('cursor', 'pointer');
		if (focus_node !== null) d = focus_node;
		highlight_node = d;

		if (highlight_color != 'white') {
			circle.style(towhite, function (o) {
				return isConnected(d, o) ? highlight_color : 'white';
			});

			text.style('font-weight', function (o) {
				return isConnected(d, o) ? 'bold' : 'normal';
			});
			link.style('stroke', function (o) {
				return o.source.index == d.index || o.target.index == d.index
					? highlight_color
					: isNumber(o.score) && o.score >= 0
					? color(o.score)
					: defaultLinkColor;
			});
		}
	}

	zoom.on('zoom', function () {
		let stroke = nominal_stroke;
		if (nominal_stroke * zoom.scale() > max_stroke)
			stroke = max_stroke / zoom.scale();
		link.style('stroke-width', function (d) {
			return linkval(d.value);
		});
		circle.style('stroke-width', stroke);

		let base_radius = nominal_base_node_size;
		if (nominal_base_node_size * zoom.scale() > max_base_node_size)
			base_radius = max_base_node_size / zoom.scale();
		circle.attr(
			'd',
			d3.svg
				.symbol()
				.size(function (d) {
					return (
						Math.PI *
						Math.pow(
							(size(d.size) * base_radius) /
								nominal_base_node_size || base_radius,
							2,
						)
					);
				})
				.type(function (d) {
					return d.type;
				}),
		);

		if (!text_center)
			text.attr('dx', function (d) {
				return (
					(size(d.size) * base_radius) / nominal_base_node_size ||
					base_radius
				);
			});

		if (nominal_text_size * zoom.scale() > max_text_size) {
			const textSize = max_text_size / zoom.scale();
		}
		text.style('font-size', function (d) {
			return fontsize(d.size) + 'em';
		});

		g.attr(
			'transform',
			'translate(' +
				d3.event.translate +
				')scale(' +
				d3.event.scale +
				')',
		);
	});

	svg.call(zoom);

	resize();

	d3.select('div.force').on('resize', resize).on('keydown', keydown);

	force.on('tick', function () {
		node.attr('transform', function (d) {
			return 'translate(' + d.x + ',' + d.y + ')';
		});
		text.attr('transform', function (d) {
			return 'translate(' + d.x + ',' + d.y + ')';
		});

		link.attr('d', function (d) {
			const dx = d.target.x - d.source.x,
				dy = d.target.y - d.source.y,
				dr = Math.sqrt(dx * dx + dy * dy);
			return (
				'M' +
				d.source.x +
				',' +
				d.source.y +
				'A' +
				dr +
				',' +
				dr +
				' 0 0,1 ' +
				d.target.x +
				',' +
				d.target.y
			);
		});

		node.attr('cx', function (d) {
			return d.x;
		}).attr('cy', function (d) {
			return d.y;
		});
	});

	function resize() {
		const width = isFilterContainerHidden ? 1200 : 1200,
			height = 560;
		svg.attr('width', width).attr('height', height);

		force
			.size([
				force.size()[0] + width / zoom.scale() - width,
				force.size()[1] + height / zoom.scale() - height,
			])
			.resume();
		w = width;
		h = height;
	}

	function keydown() {
		if (d3.event.keyCode == 32) {
			force.stop();
		} else if (
			d3.event.keyCode >= 48 &&
			d3.event.keyCode <= 90 &&
			!d3.event.ctrlKey &&
			!d3.event.altKey &&
			!d3.event.metaKey
		) {
			switch (String.fromCharCode(d3.event.keyCode)) {
				case 'C':
					keyc = !keyc;
					break;
				case 'S':
					keys = !keys;
					break;
				case 'T':
					keyt = !keyt;
					break;
				case 'R':
					keyr = !keyr;
					break;
				case 'X':
					keyx = !keyx;
					break;
				case 'D':
					keyd = !keyd;
					break;
				case 'L':
					keyl = !keyl;
					break;
				case 'M':
					keym = !keym;
					break;
				case 'H':
					keyh = !keyh;
					break;
				case '1':
					key1 = !key1;
					break;
				case '2':
					key2 = !key2;
					break;
				case '3':
					key3 = !key3;
					break;
				case '0':
					key0 = !key0;
					break;
			}

			link.style('display', function (d) {
				const flag =
					visualizeByType(d.source.type) &&
					visualizeByType(d.target.type) &&
					visualizeByNodeScore(d.source.score) &&
					visualizeByNodeScore(d.target.score) &&
					visualizeByLinkScore(d.size);
				linkedByIndex[d.source.index + ',' + d.target.index] = flag;
				return flag ? 'inline' : 'none';
			});
			node.style('display', function (d) {
				return (key0 || hasConnections(d)) &&
					visualizeByType(d.type) &&
					visualizeByNodeScore(d.size)
					? 'inline'
					: 'none';
			});
			text.style('display', function (d) {
				return (key0 || hasConnections(d)) &&
					visualizeByType(d.type) &&
					visualizeByNodeScore(d.size)
					? 'inline'
					: 'none';
			});

			if (highlight_node !== null) {
				if (
					(key0 || hasConnections(highlight_node)) &&
					visualizeByType(highlight_node.type) &&
					visualizeByNodeScore(highlight_node.score)
				) {
					if (focus_node !== null) set_focus(focus_node);
					set_highlight(highlight_node);
				} else {
					exit_highlight();
				}
			}
		}
	}

	function visualizeByType(type) {
		switch (type) {
			case 'circle':
				return keyc;
			case 'square':
				return keys;
			case 'triangle-up':
				return keyt;
			case 'diamond':
				return keyr;
			case 'cross':
				return keyx;
			case 'triangle-down':
				return keyd;
			default:
				return true;
		}
	}
	function visualizeByNodeScore(score) {
		if (isNumber(score)) {
			if (score >= 0.666) return keyh;
			else if (score >= 0.333) return keym;
			else if (score >= 0) return keyl;
		}
		return true;
	}

	function visualizeByLinkScore(score) {
		if (isNumber(score)) {
			if (score >= 0.666) return key3;
			else if (score >= 0.333) return key2;
			else if (score >= 0) return key1;
		}
		return true;
	}

	function isNumber(number) {
		return !isNaN(parseFloat(number)) && isFinite(number);
	}
}

export const tooltipStyles = {
	link: {
		fontFamily: 'var(--font-sans)',
		fontSize: '13px',
		display: 'block',
		fontStyle: 'italic',
		fontWeight: 400,
		lineHeight: '20px',
		textDecoration: 'underline',
		color: '#00579E',
	},
	title: {
		fontFamily: 'var(--font-sans)',
		fontSize: '1rem',
		fontWeight: 600,
		lineHeight: '1.5rem',
		textAlign: 'left',
		color: '#000',
		marginTop: 0,
	},
};

export function handleObjectType(corpus) {
	if (corpus[0] === 'avis') {
		return 'aviser';
	}
	return encodeURIComponent('bøker');
}
